export default {
  'pages.myApps.title': 'My apps',
  'pages.myApps.description':
    'View business apps enabled for your enterprise and start working.',
  'pages.myApps.backToCenter': 'Back to Applications',
  'pages.myApps.refresh': 'Refresh',
  'pages.myApps.browseMarket': 'Browse App Marketplace',
  'pages.myApps.overview': 'App overview',
  'pages.myApps.enabledCount': 'Enabled apps',
  'pages.myApps.availableCount': 'Ready to open',
  'pages.myApps.unconfiguredCount': 'No access URL',
  'pages.myApps.currentPackage': 'Current plan',
  'pages.myApps.packageError': 'Plan information could not be loaded.',
  'pages.myApps.retry': 'Reload',
  'pages.myApps.subscription.active': 'Active',
  'pages.myApps.subscription.expired': 'Expired',
  'pages.myApps.subscription.suspended': 'Suspended',
  'pages.myApps.subscription.cancelled': 'Cancelled',
  'pages.myApps.subscription.unknown': 'Status unavailable',
  'pages.myApps.startsAt': 'Start date',
  'pages.myApps.expiresAt': 'Expiry date',
  'pages.myApps.noExpiry': 'No expiry',
  'pages.myApps.dateUnknown': 'No date available',
  'pages.myApps.noPackage':
    'No current plan. Your enabled apps remain available.',
  'pages.myApps.appList': 'Enabled apps',
  'pages.myApps.accessDescription':
    'Apps open in a new window. Apps without an access URL cannot be opened yet.',
  'pages.myApps.searchLabel': 'Search apps',
  'pages.myApps.searchPlaceholder': 'Search by app name or ID',
  'pages.myApps.filterLabel': 'Filter by activation source',
  'pages.myApps.source.all': 'All apps',
  'pages.myApps.source.package': 'Included in plan',
  'pages.myApps.source.tenant': 'Enabled individually',
  'pages.myApps.source.other': 'Other source',
  'pages.myApps.resultCount': '{count} apps found',
  'pages.myApps.loadError': 'The app list could not be loaded',
  'pages.myApps.loadErrorDescription':
    'Reload to try again. Your app activation records are unaffected.',
  'pages.myApps.emptyTitle': 'No apps enabled yet',
  'pages.myApps.emptyDescription':
    'Browse the App Marketplace to discover business tools for your enterprise and team.',
  'pages.myApps.noResults': 'No matching apps',
  'pages.myApps.noResultsDescription':
    'Try another app name or ID, or clear the search and source filters.',
  'pages.myApps.clearFilters': 'Clear filters',
  'pages.myApps.available': 'Ready to open',
  'pages.myApps.unconfigured': 'No access URL',
  'pages.myApps.openApp': 'Open app',
  'pages.myApps.openAppAccessible': 'Open {name} (new window)',
  'pages.myApps.newWindow': 'New window',
  'pages.myApps.accessUnavailable': 'Cannot open yet',
  'pages.myApps.paginationTotal': '{total} apps in total',
};
